import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as Calendar } from '../../../assets/icons/calendar.svg';
import * as log from '../../../utils/log';
import styles from './DateInput.module.scss';
const DateInput = ({ placeholder, className, onChange, dateData }) => {
    useEffect(() => {
        log.debug(dateData);
    }, [dateData]);
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsx(DatePicker, { selected: dateData, placeholderText: placeholder, className: styles.date, onChange: (date) => {
                    const data = date;
                    onChange && onChange(data);
                } }), _jsx(Calendar, { className: styles.calendar })] })));
};
export default DateInput;
